export { default } from './SWPricingCard';
